import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Home.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <span className={`${styles.eyebrow} ${styles.reveal} ${styles.d1}`}>
          <span className={styles.dot} />Payments · Invoicing · Protection
        </span>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Get paid.<br /><span className={styles.hl}>Stay paid.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          The all-in-one financial platform for small business — accept every payment, send invoices, and keep your revenue with built-in chargeback protection.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <a href="#how" className={styles.btnOutline}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />No setup fees</span>
          <span><CheckSmall />Free to start</span>
          <span><CheckSmall />Cancel anytime</span>
        </div>
        <div className={`${styles.payPills} ${styles.reveal} ${styles.d5}`}>
          <span className={styles.lab}>Accepts</span>
          {['Fyntiq Wallet', 'Visa', 'Mastercard', 'Amex', 'Apple Pay', 'Google Pay', 'Cash App Pay', 'Bank transfers'].map((m) => (
            <span key={m} className={styles.payPill}>{m}</span>
          ))}
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}><CheckSmall /></div>
          <div><div className={styles.fcLab}>Invoice #1043</div><div className={styles.fcVal}>Paid</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#2EB66E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v13m0 0l-4-4m4 4l4-4M5 21h14" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Deposited</div><div className={styles.fcVal}>$1,240.00</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.pcTop}>
            <div className={styles.pcMerchant}>
              <div className={styles.pcLogo}>N</div>
              <div><div className={styles.pcMname}>Northbeam Studio</div><div className={styles.pcMsub}>Invoice #1043</div></div>
            </div>
            <span className={styles.pcPaid}>● Secure</span>
          </div>
          <div className={styles.pcAmtLab}>Amount due</div>
          <div className={styles.pcAmt}>$25.00</div>
          <div className={styles.pcMethods}>
            <div className={`${styles.pcM} ${styles.pcMSel}`}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="7" width="18" height="12" rx="2" /><path d="M3 11h18" /></svg>
              </span>
              Wallet
            </div>
            <div className={styles.pcM}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /></svg>
              </span>
              Card
            </div>
            <div className={styles.pcM}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 21h18M5 21V10M19 21V10M3 10l9-6 9 6" /></svg>
              </span>
              Bank
            </div>
            <div className={styles.pcM}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
              </span>
              Finance
            </div>
          </div>
          <button type="button" className={styles.pcPay}>Pay $25.00 →</button>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
